import { storyblokGlobalContentInitialState } from './storyblok-global-content.state';
import {
  LoadStoryblokGlobalContentSuccess,
  LoadStoryblokGlobalContentFailure,
  StoryblokGlobalContentActionsUnion,
  StoryblokGlobalContentActionTypes,
} from './storyblok-global-content.actions';

export function storyblokGlobalContentReducer(
  state = storyblokGlobalContentInitialState,
  action: StoryblokGlobalContentActionsUnion
) {
  switch (action.type) {
    case StoryblokGlobalContentActionTypes.LOAD_STORYBLOK_GLOBAL_CONTENT:
      return { ...state, isLoaded: false };
    case StoryblokGlobalContentActionTypes.LOAD_STORYBLOK_GLOBAL_CONTENT_SUCCESS:
      return {
        ...state,
        isLoaded: true,
        error: null,
        promoWidgetLink: (action as LoadStoryblokGlobalContentSuccess).payload?.['header-promo-widget'] || null,
        navigation: (action as LoadStoryblokGlobalContentSuccess).payload?.navigation || null,
        offerMenuContent: (action as LoadStoryblokGlobalContentSuccess).payload?.['offer-menu-content'] || null,
      };
    case StoryblokGlobalContentActionTypes.LOAD_STORYBLOK_GLOBAL_CONTENT_FAILURE:
      return {
        ...state,
        isLoaded: false,
        error: (action as LoadStoryblokGlobalContentFailure).payload,
      };
    default:
      return state;
  }
}
